import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  MyRewards as MyRewardsComponent,
  MyRewardsProps,
} from "../../components/MyRewards/MyRewards";
import { getCouponsAction, getRewardsAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getCoupons,
  getRewards,
  isGetRewardsLoading,
} from "../../reducers/reward/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface MyRewardsContainerProps extends MyRewardsProps {
  coupons: ReturnType<typeof getCoupons>;
  getCouponsAction: typeof getCouponsAction;
  getRewardsAction: typeof getRewardsAction;
  rewards: ReturnType<typeof getRewards>;
}

class MyRewards extends React.Component<MyRewardsContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getCouponsAction();
      this.props.getRewardsAction();
    }
  }

  componentDidUpdate(prevProps: MyRewardsContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      this.props.getCouponsAction();
      this.props.getRewardsAction();
    }
  }

  render() {
    return <MyRewardsComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  coupons: getCoupons(state.reward),
  isLoading: isGetRewardsLoading(state.reward),
  rewards: getRewards(state.reward),
});

export default connect(mapStateToProp, {
  getCouponsAction,
  getRewardsAction,
})(MyRewards);
